<template>
  <FaIcon :icon="ICON.CLOSE" />
</template>

<script setup lang="ts">
import { ICON } from '@/constants/icons';
</script>

